import Vue from "vue";
const getDefaultState = () => {
  return {
    horsGroupe: [],
    ////////////////
    field: "email",
    whereField: "id_responsable",
    collection: "membresHorsGroupe",
  };
};
const state = getDefaultState();

const mutations = {
  SET_LISTE(state, payload) {
    state.horsGroupe = payload;
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
    // console.log("horsGroupe state reseted");
  },
};

const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },
  async GetAll({ commit, dispatch }, uid) {
    // console.log("tooooooooonaga eto")
    // start requête
    commit("SET_LISTE", []);

    commit("Loading/START_BUSY_STATE", "horsGroupe.store.js", { root: true });

    let elems = [];
    this._vm.$firebase
      .firestore()
      .collection("membresHorsGroupe")
      .where("id_responsable", "==", uid.toString())
      .get()
      .then(
        (snapshot) => {
          snapshot.docChanges().forEach(function (change) {
            commit("SET_LISTE", []);
            /*  if (change.type === "added") {
                console.log("New Groupe: ", change.doc.data());
              
            }
            if (change.type === "modified") {
                console.log("Modified Group: ", change.doc.data());
                
            }
            if (change.type === "removed") {
                console.log("Removed Group: ", change.doc.data());
               
            } */
          });

          if (snapshot.metadata.hasPendingWrites) {
            console.log("il en reste dans horsGroupe");
            commit("Pending/START_PENDING_STATE", null, { root: true });
          } else {
            console.log("tout est synchronisé dans horsGroupe");
            commit("Pending/END_PENDING_STATE", null, { root: true });
          }
          snapshot.forEach(function (doc) {
            elems.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          if (!elems) {
            console.log("No Data Available");
            return false;
          } else {
            commit("SET_LISTE", elems);
            commit("Loading/END_BUSY_STATE", "horsGroupe.store.js", {
              root: true,
            });
          }
        },
        (error) => {
          console.log(error);
          let snackbar = {};
          snackbar.showSnackbar = true;
          snackbar.snackbarContent = error.message;
          commit("Snackbar/SET_SNACKBAR", snackbar, { root: true });
          commit("Loading/END_BUSY_STATE", "horsGroupe.store.js", {
            root: true,
          });
        }
      );
  },
};

const getters = {
  horsGroupe: (state) => {
    return state.horsGroupe;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
